module.exports = __webpack_public_path__ + "img/redculture1.52949392.jpg";